import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationServiceDetailResponse,
  IConfigurationServiceDetailResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useConfigurationServiceDetailAPI = () => {
  const [serviceDetails, setServiceDetails] = useState<IConfigurationServiceDetailResponseData | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (service_id: string, subServiceId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!subServiceId) {
          return;
        }
        await axios
          .get(
            `${CONFIGURATION_APIS?.SERVICE_DETAIL?.baseURL}?sub_service_id=${subServiceId}&service_id=${service_id}`,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IConfigurationServiceDetailResponse>) => {
            if (res.data.status === true) {
              setServiceDetails(res.data.data);
            } else {
              setServiceDetails(null);
              toast.error("Error while fetching service details.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            setServiceDetails(null);
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        setServiceDetails(null);
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching city details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { serviceDetails, execute };
};
